module.exports = __webpack_public_path__ + "static/img/HARRISON-WILSON.a66bb7a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/HARRISON-WILSON.jpg
// module id = 6k/W
// module chunks = 0